import React, { useEffect, useState, useMemo } from "react";
import { connect } from "react-redux";
import { getDataFromAPI } from "../../HandleAPICalls/actions";
import { UsersroleList } from "./component";

const CouponListContainer = (props) => {
  const [activatedCoupons, setActivatedCoupons] = useState([]);
  const [deactivatedCoupons, setDeactivatedCoupons] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [query, setQuery] = useState('');
  const [statusFilter, setStatusFilter] = useState('All');


  useEffect(() => {
    setLoading(true);
    props.getDataFromAPI(
      "/partner/api/v1/coupon/fetchAll",
      "GET",
      undefined,
      (response) => {
        setActivatedCoupons(response.activatedCoupons || []);
        setDeactivatedCoupons(response.deactivatedCoupons || []);
        setLoading(false);
      },
      (error) => {
        setError("Failed to fetch coupons");
        setLoading(false);
      }
    );
  }, [props]);

  const allCoupons = useMemo(() => [
    ...activatedCoupons.map(c => ({ ...c, status: 'Activated' })),
    ...deactivatedCoupons.map(c => ({ ...c, status: 'Deactivated' }))
  ], [activatedCoupons, deactivatedCoupons]);

const filtered = useMemo(() => {
  const search = query.trim().toLowerCase();

  let baseList = [];

  if (statusFilter === 'Activated') {
    baseList = activatedCoupons.map(c => ({ ...c, status: 'Activated' }));
  } else if (statusFilter === 'Deactivated') {
    baseList = deactivatedCoupons.map(c => ({ ...c, status: 'Deactivated' }));
  } else {
    baseList = allCoupons;
  }

  if (!search) return baseList;

  return baseList.filter(c =>
    (c.couponName && c.couponName.toLowerCase().includes(search)) ||
    (c.couponId && c.couponId.toString().includes(search))
  );
}, [query, allCoupons, activatedCoupons, deactivatedCoupons, statusFilter]);


  return (
    <>
  

   

      <UsersroleList
        loading={loading}
        filtered={filtered}
        setQuery={setQuery}
        statusFilter={statusFilter} 
        setStatusFilter={setStatusFilter} // optional if UsersroleList uses it internally
      />
    </>
  );
};

function mapStateToProps(state) {
  return {
    // Add redux state here if needed
  };
}

export default connect(mapStateToProps, {
  getDataFromAPI,
})(CouponListContainer);
